import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    description: 'Region picker, press Tab key to navigate within a level and press Left/Right Arrow key to switch levels'
  },
  {
    ns: 'regionpicker'
  }
)
